module.exports = __webpack_public_path__ + "static/media/photo181.ccbb3ea2.jpg";